<script>
import {
  redirectToContactUs,
  redirectToHome
} from "../../helpers/routerHelper";

export default {
  name: "HeaderSection",
  methods: {
    redirectToHome
  }
};
</script>

<template>
  <el-header class="header-outer-wrapper" >
    <el-row>
      <el-col :span="12" class="left-centered">
        <img
          src="../../assets/unifi-logo-new-with-text-green.svg"
          style="width: 250px; height: 42px"
          @click="redirectToHome"
        />
      </el-col>
      <el-col :span="12" class="right-centered">
        <img src="../../assets/menu-alt-new.svg"
             style="height: 50px"
             @click="$emit('spread')" />
      </el-col>
    </el-row>
  </el-header>
</template>

<style lang="scss" scoped>
.header-outer-wrapper {
  background-color: #ffffff;
  padding: 0;
  height: 80px !important;
}
.right-centered {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 16px 16px 16px 0;
}

.left-centered {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 16px 0 16px 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/package/HeaderSection.vue